import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaRegLightbulb, FaCouch, FaTree, FaStar, FaHome } from "react-icons/fa";

const RopeLightIdeas = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#542757] to-[#9b1f6c] text-white">
      <Navbar />

      {/* Header Section */}
      <div className="max-w-6xl mx-auto px-6 py-16 mt-10">
        <motion.h1
          className="text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-yellow-400 mb-8 drop-shadow-lg"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Rope Light Ideas
        </motion.h1>

        <motion.p
          className="text-white/80 text-lg text-center mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Add warmth, creativity, and personality to your spaces using flexible, colorful, and 
          energy-efficient rope lights. Perfect for both indoor and outdoor settings!
        </motion.p>

        {/* Ideas Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Idea 1 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-xl transition"
            whileHover={{ scale: 1.03 }}
          >
            <FaCouch className="text-pink-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">
              1. Cozy Living Room Accents
            </h2>
            <p className="text-white/80">
              Outline your furniture, ceilings, or wall frames with warm white rope lights 
              to create a calm and inviting ambiance for relaxing evenings.
            </p>
          </motion.div>

          {/* Idea 2 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-xl transition"
            whileHover={{ scale: 1.03 }}
          >
            <FaTree className="text-green-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">
              2. Garden & Outdoor Glow
            </h2>
            <p className="text-white/80">
              Wrap rope lights around trees, fences, or patios to bring your outdoor area 
              to life — ideal for festive nights or evening get-togethers.
            </p>
          </motion.div>

          {/* Idea 3 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-xl transition"
            whileHover={{ scale: 1.03 }}
          >
            <FaStar className="text-yellow-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">
              3. Bedroom Starry Vibes
            </h2>
            <p className="text-white/80">
              Add rope lights behind your bed frame, mirrors, or headboard to create a dreamy, 
              soft glow for a peaceful retreat.
            </p>
          </motion.div>

          {/* Idea 4 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-xl transition"
            whileHover={{ scale: 1.03 }}
          >
            <FaHome className="text-purple-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">
              4. Festive Home Décor
            </h2>
            <p className="text-white/80">
              Use colored rope lights during holidays and special events to make your 
              home more cheerful and vibrant.
            </p>
          </motion.div>

          {/* Idea 5 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-xl transition"
            whileHover={{ scale: 1.03 }}
          >
            <FaRegLightbulb className="text-orange-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">
              5. Creative DIY Projects
            </h2>
            <p className="text-white/80">
              Experiment with rope lights for signage, art outlines, or furniture accents — 
              your creativity is the limit!
            </p>
          </motion.div>
        </div>

        {/* Call to Action */}
        <motion.div
          className="mt-16 text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <h3 className="text-2xl font-semibold text-white mb-3">
            Let Your Creativity Shine ✨
          </h3>
          <p className="text-white/80 mb-6">
            Discover HLC’s wide range of rope lights for both indoor and outdoor use — 
            flexible, durable, and perfect for any décor style.
          </p>
          {/* Filters the shop to Rope Light Series, reusing the existing
              filtering system */}
          <button
            type="button"
            onClick={() => navigate("/shop", { state: { category: "ROPE LIGHT SERIES" } })}
            className="inline-block bg-gradient-to-r from-pink-500 to-yellow-400 text-white font-medium px-6 py-3 rounded-full shadow-md hover:shadow-lg transition"
          >
            Explore Rope Lights
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default RopeLightIdeas;
